import { css } from "@emotion/react";

export const styles = {
  media: css`
    width: 45px;
    height: 45px;
    object-fit: cover;
    border-radius: 100%;
    overflow: hidden;
  `,
  playbuttom_image: css`
    width: 30px;
    height: 30px;
    position: absolute;
  `
};
